import { render, staticRenderFns } from "./CartOverviewItem.vue?vue&type=template&id=3bb593e0&scoped=true&"
import script from "./CartOverviewItem.vue?vue&type=script&lang=js&"
export * from "./CartOverviewItem.vue?vue&type=script&lang=js&"
import style0 from "./CartOverviewItem.vue?vue&type=style&index=0&id=3bb593e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb593e0",
  null
  
)

export default component.exports